import utils from '../../utils/index'
import { formatarTexto } from '../../components/agendamentoRelatorio/filtrosSalvos.utils'

// PHOENIX-977: regras da tela da remessa, fora do container para teste.

export const STATUS_REMESSA = {
  SUCESSO: 1,
  ERRO: 2,
  PENDENTE: 3,
  GERANDO_LANCAMENTOS: 500,
  EMITINDO_BOLETOS: 501,
}

export const STATUS_ITEM = {
  SUCESSO: 1,
  ERRO: 2,
  AGUARDANDO_EMISSAO: 500,
}

const label = (messages, chave, ...parametros) =>
  formatarTexto(utils.getMessage(messages, `consultaremessa.label.${chave}`), ...parametros)

/** Remessa assincrona com os jobs trabalhando nela: ninguem mexe (reprocessar e recusado no back). */
export const emProcessamento = (record) =>
  [STATUS_REMESSA.GERANDO_LANCAMENTOS, STATUS_REMESSA.EMITINDO_BOLETOS].includes(record && record.status)

/** Quantidade de itens no status, pelas contagens do formulario (a grade so tem a pagina). */
export const contagem = (record, status) => {
  const valor = record && record.contagemItens ? record.contagemItens[status] : 0
  return Number(valor || 0)
}

/**
 * Item com lancamento: o unico que se reprocessa. O item em ERRO sem lancamento e o contrato que nao gerou
 * (remessa assincrona) ou a remessa de erro do sincrono - fica na grade so para mostrar a mensagem.
 */
export const itemSelecionavel = (item) =>
  !!item && item.oidLancamentoFinanceiro !== undefined && item.oidLancamentoFinanceiro !== null

/**
 * showSelectionElement do DataTable: esconde o checkbox da linha sem lancamento. So o isDataSelectable bloqueia
 * a selecao, mas no PrimeReact 9.2 o checkbox continua desenhado como ativo. O PrimeReact chama esta funcao de
 * dois jeitos: na celula, (rowData, { rowIndex, props }); no "selecionar todos", so ({ rowIndex, props }), sem a
 * linha - ai devolve true e quem filtra e o isDataSelectable. Para esconder devolve null, nao false: a celula e
 * `showSelection && <checkbox>`, e o false aparecia escrito na grade (teste de tela 04/11).
 */
export const mostrarCheckbox = (rowData, opcoes) => {
  if (opcoes === undefined) {
    return true
  }
  return itemSelecionavel(rowData) ? true : null
}

export const itensComErroSelecionados = (selecionados) =>
  (selecionados || []).filter((item) => item.status === STATUS_ITEM.ERRO && itemSelecionavel(item))

/** Itens em ERRO que tem lancamento: o "Erro: N" do resumo menos os erros da geracao (sem lancamento). */
export const errosReprocessaveis = (record) =>
  Math.max(0, contagem(record, STATUS_ITEM.ERRO) - Number((record && record.itensErroSemLancamento) || 0))

export const podeReprocessarSelecionados = (record, selecionados) =>
  !emProcessamento(record) && itensComErroSelecionados(selecionados).length > 0

/**
 * "Reprocessar todos com erro": manda a lista vazia, e o back pega todos os itens em ERRO. So na remessa
 * assincrona (review 30/10, M8): na sincrona o back reemite tudo dentro do request (258 itens em ERRO =
 * minutos, 504 do gateway com o back seguindo), e a sincrona fica como era antes - so por selecao. Na
 * assincrona fechada em ERRO antes do primeiro lote (configuracao perdida) nao ha item em ERRO, so itens
 * ainda sem boleto: e o unico caminho para retomar a emissao dela.
 */
export const podeReprocessarTodos = (record) => {
  if (!record || !record.assincrona || emProcessamento(record)) {
    return false
  }
  if (errosReprocessaveis(record) > 0) {
    return true
  }
  return (
    fechaComoSucesso(record) ||
    (record.status === STATUS_REMESSA.ERRO && contagem(record, STATUS_ITEM.AGUARDANDO_EMISSAO) > 0)
  )
}

/**
 * Remessa assincrona em ERRO sem item em ERRO nem aguardando: cancelada quando so faltavam os em voo, que
 * terminaram emitidos. O "Reprocessar todos" fecha ela em SUCESSO (o back confere de novo, com a trava).
 * Os erros da geracao (sem lancamento) nao contam - nem como item, nem como erro: so o item com lancamento
 * decide o desfecho da remessa.
 */
export const fechaComoSucesso = (record) =>
  !!record &&
  !!record.assincrona &&
  record.status === STATUS_REMESSA.ERRO &&
  Number(record.totalItens || 0) - Number(record.itensErroSemLancamento || 0) > 0 &&
  errosReprocessaveis(record) === 0 &&
  contagem(record, STATUS_ITEM.AGUARDANDO_EMISSAO) === 0

/**
 * "Reprocessar todos com erro" so existe na remessa assincrona (review 30/10, M8). A sincrona - inclusive
 * CNAB 400, que nunca e assincrona - fica como antes do PHOENIX-977: so o botao por selecao.
 */
export const exibeReprocessarTodos = (record) => !!(record && record.assincrona)

export const podeCancelarPendentes = (record) => !!(record && record.assincrona) && emProcessamento(record)

/** Corpo do POST /remessasfinanceiras/{oid}/itens a partir do estado do DataTable e dos filtros da grade. */
export const paramsPaginaItens = (pagina, filtros) => {
  const f = filtros || {}
  const lancamento = String(
    f.oidLancamentoFinanceiro === undefined || f.oidLancamentoFinanceiro === null ? '' : f.oidLancamentoFinanceiro
  ).trim()
  const mensagem = String(f.mensagem || '').trim()
  return {
    first: pagina.first || 0,
    rows: pagina.rows || 15,
    sortField: pagina.sortField || null,
    sortOrder: pagina.sortOrder || null,
    status: f.status === '' || f.status === undefined ? null : f.status,
    // filtro exato pelo lancamento: so digitos viram filtro; o resto e ignorado em vez de nao achar nada
    oidLancamentoFinanceiro: /^\d+$/.test(lancamento) ? Number(lancamento) : null,
    mensagem: mensagem === '' ? null : mensagem,
  }
}

export const textoConfirmacaoReprocessarTodos = (messages, record) => {
  if (fechaComoSucesso(record)) {
    return label(messages, 'confirmaFecharSucesso')
  }
  const comErro = errosReprocessaveis(record)
  if (comErro > 0) {
    return label(messages, 'confirmaReprocessarTodos', comErro)
  }
  return label(messages, 'confirmaRetomarEmissao', contagem(record, STATUS_ITEM.AGUARDANDO_EMISSAO))
}

/**
 * Mensagens depois do reprocesso. A remessa assincrona devolve o resumo; a sincrona, nada (cria remessa
 * nova). Sobrando item em ERRO, um aviso a parte: a remessa vai fechar em ERRO de novo por eles.
 */
export const mensagensResultadoReprocesso = (messages, resultado) => {
  if (!resultado || typeof resultado !== 'object') {
    return [{ tipo: 'success', texto: label(messages, 'resultadoReprocessoSincrono') }]
  }
  if (resultado.fechadaComoSucesso) {
    return [{ tipo: 'success', texto: label(messages, 'resultadoFechadaSucesso') }]
  }
  const mensagens = [
    { tipo: 'success', texto: label(messages, 'resultadoReprocessoAssincrono', resultado.itensAguardando || 0) },
  ]
  if (resultado.itensErroRestantes > 0) {
    mensagens.push({
      tipo: 'warn',
      texto: label(messages, 'resultadoReprocessoRestantes', resultado.itensErroRestantes),
    })
  }
  return mensagens
}

export const mensagemResultadoCancelamento = (messages, resultado) =>
  label(messages, 'resultadoCancelamento', (resultado && resultado.itensCancelados) || 0)

/** Linhas do resumo: o nome do status (enum do front, o mesmo da grade) e a quantidade. */
export const linhasContagem = (record, nomeStatus) =>
  Object.keys((record && record.contagemItens) || {})
    .map((codigo) => ({
      codigo: Number(codigo),
      nome: nomeStatus(Number(codigo)),
      quantidade: contagem(record, codigo),
    }))
    .sort((a, b) => a.codigo - b.codigo)

/**
 * Texto da opcao de status no filtro das grades (PHOENIX-977, review B15): do dicionario, em caixa alta como as
 * opcoes antigas ao lado (TODOS, SUCESSO, ERRO), que sao fixas no codigo.
 */
export const opcaoFiltroStatus = (texto) => String(texto || '').toUpperCase()

/**
 * Opcoes do filtro sem as que ficaram sem texto. Os labels do dicionario sao lidos so no login: quem ja estava
 * logado quando a chave nova entrou ve o label vazio ate logar de novo - melhor a opcao nao aparecer do que
 * aparecer em branco (review 30/10, rodada 2, B2).
 */
export const semOpcaoVazia = (opcoes) => (opcoes || []).filter((opcao) => !!opcao.label)

export const textoStatusItem = (messages, status) => label(messages, `itemStatus${status}`)

export const textoStatusRemessa = (messages, status) => {
  const chaves = {
    [STATUS_REMESSA.SUCESSO]: 'statusSucesso',
    [STATUS_REMESSA.ERRO]: 'statusErro',
    [STATUS_REMESSA.PENDENTE]: 'statusPendente',
    [STATUS_REMESSA.GERANDO_LANCAMENTOS]: 'statusGerandoLancamentos',
    [STATUS_REMESSA.EMITINDO_BOLETOS]: 'statusEmitindoBoletos',
  }
  return chaves[status] ? label(messages, chaves[status]) : ''
}

/** Nome do status do item (boleto e Vindi); codigo sem label sai como numero. */
export const nomeStatusItem = (messages, codigo) => {
  const texto = label(messages, `itemStatus${codigo}`)
  return texto || String(codigo)
}

export { label as labelConsultaRemessa }
